import script from "./AyeletEmailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AyeletEmailsView.vue?vue&type=script&setup=true&lang=js"

import "./AyeletEmailsView.vue?vue&type=style&index=0&id=70a49d66&lang=scss"

const __exports__ = script;

export default __exports__